<template>
  <div id="post-detail" v-loading="loading">
    <div class="app-top">
      <!-- <swiper-list :dataList="swiperList" :height="350" :interval="4000"></swiper-list> -->
    </div>
    <div class="container">
      <div class="f-box">
        <div class="box" id="detail">
          <h3>{{detail.title||'...'}}</h3>
          <div style="margin-top: 20px;" v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/post'

export default {
  name: 'PostDetail',
  components: {},
  data() {
    return {
      loading: true,
      code: '',
      detail: {}
    }
  },
  watch: {
    // '$route.params.code'() {
    //   this.code = this.$route.params.code
    //   this.getOne()
    // }
  },
  computed: {
    // code() {
    //   return this.$route.params.code
    // }
  },
  created() {
    console.log(this.$route.params)
    this.code = this.$route.params.code
    if (this.code) {
      this.getOne()
    }
  },
  methods: {
    getOne() {
      this.loading = true
      API.getOne({ id: this.code }).then(res => {
        this.detail = res.data
        document.title = `${this.detail.title} - ${this.gSetting.common.name}`
        this.loading = false
      })
    }
  },

  mounted() {}
}
</script>

<style>
/* 移动端 */
@media screen and (max-width: 576px) {
  #post-detail .f-box h3 {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  #post-detail .f-box img {
    width: 100% !important;
  }
}
#post-detail .ql-align-right {
  text-align: right;
}
#post-detail .ql-align-center {
  text-align: center;
}
</style>
<style lang="scss" scoped>
// 移动端 vhtml里元素 不生效
// @media screen and (max-width: 576px) {
//   #post-detail {
//     .f-box {
//       h3 {
//         font-size: 18px !important;
//         font-weight: 500 !important;
//       }
//       img {
//         width: 100% !important;
//         padding: 10px !important;
//       }
//     }
//   }
// }
// 电脑端
.app-top {
  margin-top: 58px;
}
#post-detail {
  .container {
    margin-top: 20px;
    padding-bottom: 30px;
    background-color: #fff;

    .f-box {
      margin: 10px auto 0 auto;
      h3 {
        padding: 15px 0;
        text-align: center;
        border-bottom: 1px solid #e6e6e6;
      }
      .box {
        padding: 10px 0;
        p {
          color: #888;
          line-height: 1.8;
        }
        .ql-align-right {
          text-align: right !important;
        }
        .ql-align-center {
          text-align: center;
        }
      }
    }
  }
}
</style>